"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transportStateOption = exports.thirdOrderStateOption = exports.pintuanOrderStates = exports.pinOrderStateOption = exports.payTypeOptions = exports.orderTypeOption = exports.orderStateOption = exports.orderCardOption = exports.offsetStateOption = exports.movieOrderStateOption = exports.mealOrderStates = exports.kamiTypeOptions = exports.integralOrderTypeOptions = exports.goodsTypeOption = exports.customerStateOptions = exports.customerOrderOptions = exports.cackOrderStateOption = void 0;
var orderStateOption = exports.orderStateOption = [
// 订单状态
{
  value: 0,
  label: '已取消'
}, {
  value: 1,
  label: '待支付'
}, {
  value: 2,
  label: '已支付'
}, {
  value: 3,
  label: '处理中'
}, {
  value: 4,
  label: '已发货'
}, {
  value: 5,
  label: '已签收'
}, {
  value: 6,
  label: '已完结'
}, {
  value: 7,
  label: '退款中'
}, {
  value: 14,
  label: '部分退款'
}, {
  value: 16,
  label: '部分发货'
}, {
  value: 8,
  label: '退款成功'
}, {
  value: 9,
  label: '退款失败'
}];
var orderTypeOption = exports.orderTypeOption = [
// 订单类型
{
  value: 0,
  label: '普通订单',
  type: 'info'
}, {
  value: 1,
  label: '卡劵订单',
  type: 'success'
}, {
  value: 2,
  label: '福司令订单',
  type: ''
}, {
  value: 3,
  label: '电影订单',
  type: 'warning'
}, {
  value: 4,
  label: '拼团订单',
  type: 'danger'
}];
var pintuanOrderStates = exports.pintuanOrderStates = [
// 拼团订单状态
{
  value: 1,
  label: '进行中'
}, {
  value: 2,
  label: '已完成'
}, {
  value: 3,
  label: '未完成'
}, {
  value: 4,
  label: '已取消'
}];
var mealOrderStates = exports.mealOrderStates = [
// 点餐订单状态
{
  value: 1,
  label: '支付中'
}, {
  value: 2,
  label: '出餐中'
}, {
  value: 3,
  label: '出餐成功'
}, {
  value: 4,
  label: '出餐失败'
}, {
  value: 5,
  label: '取消订单'
}, {
  value: 6,
  label: '订单完成'
}, {
  value: 8,
  label: '订单配送'
}, {
  value: 9,
  label: '部分退款'
}, {
  value: 11,
  label: '订单未支付过期'
}];
var virtualStateOption = [// 订单状态
];
var thirdOrderStateOption = exports.thirdOrderStateOption = [
// 三方订单-订单状态
{
  value: -2,
  label: '已取消'
}, {
  value: -1,
  label: '待支付'
}, {
  value: 0,
  label: '未知'
}, {
  value: 1,
  label: '进行中'
}, {
  value: 2,
  label: '充值成功'
}, {
  value: 3,
  label: '充值失败'
}, {
  value: 4,
  label: '购买超限'
}];
var transportStateOption = exports.transportStateOption = [
// 物流状态
{
  value: 0,
  label: '在途中'
}, {
  value: 1,
  label: '已揽收'
}, {
  value: 5,
  label: '派件中'
}, {
  value: 3,
  label: '已签收'
}, {
  value: 6,
  label: '已退回'
}, {
  value: 4,
  label: '退回签收'
}, {
  value: 7,
  label: '转投'
}, {
  value: 2,
  label: '疑难'
}, {
  value: 8,
  label: '清关'
}, {
  value: 14,
  label: '拒签'
}];
var goodsTypeOption = exports.goodsTypeOption = [
// 销售渠道
{
  value: 1,
  label: '平台自营'
}];
var orderCardOption = exports.orderCardOption = [
// 卡密状态
{
  value: 1,
  label: '已生成'
}, {
  value: 2,
  label: '已绑定'
}, {
  value: 3,
  label: '已作废'
}, {
  value: 4,
  label: '已作废-部分回收'
}, {
  value: 5,
  label: '已核销'
}, {
  value: 6,
  label: '已过期'
}];
var customerOrderOptions = exports.customerOrderOptions = [
// 客户订单类型
{
  value: 1,
  label: '用户自选'
}, {
  value: 2,
  label: '福豆充值'
}, {
  value: 3,
  label: '权益卡包'
}];
var customerStateOptions = exports.customerStateOptions = [
// 客户订单状态
{
  value: -2,
  label: '已删除'
}, {
  value: -1,
  label: '卡密生成中'
}, {
  value: 0,
  label: '作废'
}, {
  value: 1,
  label: '已下单'
}, {
  value: 2,
  label: '已确认'
}, {
  value: 3,
  label: '已生成订单'
}];
var payTypeOptions = exports.payTypeOptions = [
// 订单支付方式
{
  value: 1,
  label: '微信支付'
}, {
  value: 2,
  label: '微信支付+积分支付'
}, {
  value: 3,
  label: '积分支付'
}, {
  value: 4,
  label: '微信支付+卡券抵扣'
}, {
  value: 5,
  label: '卡券抵扣'
}];
var movieOrderStateOption = exports.movieOrderStateOption = [{
  value: '订单取消',
  label: '订单取消'
}, {
  value: '待支付',
  label: '待支付'
}, {
  value: '出票失败',
  label: '出票失败'
}, {
  value: '出票中',
  label: '出票中'
}, {
  value: '退款成功',
  label: '退款成功'
}];
var pinOrderStateOption = exports.pinOrderStateOption = [{
  value: 1,
  label: '进行中'
}, {
  value: 2,
  label: '已完成'
}, {
  value: 3,
  label: '未完成'
}, {
  value: 4,
  label: '已取消'
}];
var cackOrderStateOption = exports.cackOrderStateOption = [{
  value: '已取消',
  label: '已取消'
}, {
  value: '已下单',
  label: '已下单'
}, {
  value: '已支付',
  label: '已支付'
}, {
  value: '已发货',
  label: '已发货'
}, {
  value: '已签收',
  label: '已签收'
}, {
  value: '已完结',
  label: '已完结'
}];
var offsetStateOption = exports.offsetStateOption = [{
  value: 0,
  label: '已取消'
}, {
  value: 1,
  label: '待支付'
}, {
  value: 2,
  label: '已支付'
}, {
  value: 6,
  label: '已完结'
}, {
  value: 7,
  label: '退款中'
}, {
  value: 8,
  label: '退款成功'
}, {
  value: 14,
  label: '部分退款'
}];
var kamiTypeOptions = exports.kamiTypeOptions = [{
  label: '卡密绑定',
  value: 1
}, {
  label: '付款码实体卡',
  value: 2
}];
var integralOrderTypeOptions = exports.integralOrderTypeOptions = [{
  label: '返积分订单',
  value: 1
}, {
  label: '兑换积分订单',
  value: 2
}];